import { createMultiStyleConfigHelpers as e, defineStyle as i } from "@chakra-ui/react";
const { definePartsStyle: t, defineMultiStyleConfig: o } = e([
  "base",
  "icon",
  "iconActive"
]), s = t({
  base: i({
    position: "relative",
    display: "inline-block"
  }),
  icon: i({
    position: "absolute",
    top: 0,
    left: 0,
    color: "primary.300"
  }),
  iconActive: i({
    color: "primary.700"
  })
}), n = i({
  sm: {
    base: {
      width: 4,
      height: 4
    },
    icon: {
      width: 4,
      height: 4
    }
  },
  md: {
    base: {
      width: 5,
      height: 5
    },
    icon: {
      width: 5,
      height: 5
    }
  },
  lg: {
    base: {
      width: 6,
      height: 6
    },
    icon: {
      width: 6,
      height: 6
    }
  }
}), h = o({ baseStyle: s, sizes: n, defaultProps: { size: "sm" } });
export {
  h as SortIcon
};
//# sourceMappingURL=SortIcon.es.js.map
